import React from 'react';

const Logo = ({ size = 'medium', className = '', showText = true }) => {
  const getSize = () => {
    switch (size) {
      case 'small': return { width: 80, height: 32 };
      case 'large': return { width: 120, height: 48 };
      case 'xl': return { width: 160, height: 64 };
      case 'xxl': return { width: 200, height: 80 };
      default: return { width: 100, height: 40 };
    }
  };

  const { width, height } = getSize();

  // Local asset (public/)
  const logoSrc = '/KG-Logo---Purple-white-&-blue-Text-(no-background)-final-final.png';

  return (
    <div className={`d-flex align-items-center ${className}`}>
      {/* Logo Image - contains both logo and text */}
      <img
        src={logoSrc}
        alt="Kross Global Logo"
        width={width}
        height={height}
        style={{ 
          objectFit: 'contain',
          maxWidth: '100%',
          height: 'auto'
        }}
        onError={(e) => {
          console.log('Logo failed to load:', e.target.src);
          e.target.style.display = 'none';
        }}
      />
    </div>
  );
};

export default Logo;
